<div class="wrapper-config-menu menu">

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header menu-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config   [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config    [device]="device"   [elementChoosing]="objectChoosing" [width]="class['information']['width']" [height]="class['information']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline">

      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu0" (nzOpenChange)="openHandler('menu0')">
        <div class="button-size">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <!-- HIỂN THỊ NỘI DUNG-->
      <li nz-submenu nzTitle="{{'hien_thi_noi_dung'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <div class="button-size">
          <div *ngFor="let item of menuList" class="item-basic">
            <div class="text-basic" style="display: flex; align-items: center">
              {{'an_/_hien_thi' | translate}} {{item.name | translate}}
            </div>
            <nz-switch [(ngModel)]="config.menu_item_hidden[item.key]"
              (ngModelChange)="updateConfig()"></nz-switch>
          </div>

        </div>
      </li>

      <!-- CẤU HÌNH MENU -->
      <li nz-submenu nzTitle="{{'cau_hinh_menu'| translate}}">
        <ul>
          <!-- Định dạnh chữ -->
          <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}" [(nzOpen)]="openMap.menu1"
            (nzOpenChange)="openHandler('menu1')">
            <div class="field-format-font menu-field ">
              <div class="container-font field-font">
                <div class="config-font-size">
                  <!-- Font-family -->
                  <div class="field-row-font" style="width:65%">
                    <mat-form-field style="width:100%">
                      <mat-label>Font</mat-label>
                      <mat-select [(value)]="class['menu__item--content']['font-family']"
                        [(ngModel)]="class['menu__item--content']['font-family']" (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="field-row-size" style="width:35%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                      <input matInput type="number" [ngModel]="class['menu__item--content']['font-size'] | vhnumber"
                        (ngModelChange)="class['menu__item--content']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                                               class['menu__item--content']['font-weight'] == 'bold'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['font-weight'] =
                                                   class['menu__item--content']['font-weight'] == 'bold'
                                                       ? '400'
                                                       : 'bold';
                                               updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                               class['menu__item--content']['font-style'] == 'italic'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['font-style'] =
                                                   class['menu__item--content']['font-style'] == 'normal'
                                                       ? 'italic'
                                                       : 'normal';
                                               updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                               class['menu__item--content']['text-decoration'] == 'underline'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['text-decoration'] =
                                                   class['menu__item--content']['text-decoration'] == 'none'
                                                       ? 'underline'
                                                       : 'none';
                                               updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                               class['menu__item--content']['text-transform'] == 'uppercase'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item--content']['text-transform'] =
                                                   class['menu__item--content']['text-transform'] == 'none'
                                                       ? 'uppercase'
                                                       : 'none';
                                               updateClass()">
                      <span>AB</span>
                    </button>

                    <!-- Màu chữ -->
                    <div>
                      <input class="round-input-color" type="button"  [cpOKButton]="true" [(colorPicker)]="class['menu__item--content']['color']"
                        [style.background]="class['menu__item--content']['color']" (colorPickerClose)="updateObject()"
                        [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                    </div>
                    <!-- Màu chữ -->

                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- Cấu hình màu nền menu -->
          <li class="pl-2" nz-submenu nzTitle="{{'mau_nen_menu' | translate}}" [(nzOpen)]="openMap.menu3"
            (nzOpenChange)="openHandler('menu3')">
            <div class="container-color">
              <button id="btn-color" *ngFor="let background of backgroundColor; let i = index"
                [ngStyle]="{'background-color':background.bgColor }" (click)="chooseBg(background, $event,'menu')"
                nz-tooltip>
              </button>
            </div>
            <div class="color-pick" style="display: flex; align-items: center; justify-content: space-between;">
              <span class="title w-50">{{'chon_mau' | translate}}</span>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="class['menu__item']['background-color']"
                [style.background]="class['menu__item']['background-color']" (colorPickerClose)="updateClass()"
                [cpPositionRelativeToArrow]="true" />
            </div>
          </li>

          <!-- Cấu hình màu nền nội dung bên trái -->
          <li class="pl-2" nz-submenu nzTitle="{{'mau_nen_noi_dung_ben_trai' | translate}}" [(nzOpen)]="openMap.menu4"
            (nzOpenChange)="openHandler('menu4')">

            <div class="color-pick" style="display: flex; align-items: center; justify-content: space-between;">
              <span class="title w-50">{{'chon_mau' | translate}}</span>
              <input class="input-color w-50" type="button"
                [cpOKButton]="true" [(colorPicker)]="class['information__menu']['background-color']"
                [style.background]="class['information__menu']['background-color']" (colorPickerClose)="updateClass()"
                [cpPositionRelativeToArrow]="true" />
            </div>
          </li>
          <!-- Cấu hình màu nền nội dung bên trái -->

        </ul>
      </li>

      <!-- HIỆU ỨNG MENU -->
      <li nz-submenu nzTitle="{{'hieu_ung_menu'| translate}}">
        <ul>
          <!-- Màu khi chạm -->
          <li *ngIf="device == 'desktop'" class="pl-2" nz-submenu nzTitle="{{'mau_khi_cham' | translate}}">
            <div class="config-name">
              <p>{{'mau_chu' | translate}}</p>
              <div style="width:50%; max-width:50%;">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_hover_menu_item.color"
                  [style.background]="config.desktop_hover_menu_item.color" (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <div class="config-name">
              <p>{{'mau_nen' | translate}} </p>
              <div style="width:50%; max-width:50%;">
                <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                  [cpOKButton]="true" [(colorPicker)]="config.desktop_hover_menu_item.background_color"
                  [style.background]="config.desktop_hover_menu_item.background_color"
                  (colorPickerClose)="updateObject()" />
              </div>
            </div>
            <div class="field-timeline">
              <div class="config-name mb-0">
                <p>{{'thoi_gian' | translate}}(s)</p>
                <nz-input-number [nzMin]="0.3" [nzStep]="0.1" [nzMax]="1"
                  [(ngModel)]="config.desktop_hover_menu_item.transition" (nzBlur)="updateObject()">
                </nz-input-number>
              </div>
              <nz-slider [nzMin]="0.3" [nzStep]="0.1" [nzMax]="1"
                [(ngModel)]="config.desktop_hover_menu_item.transition" (nzOnAfterChange)="updateObject()">
              </nz-slider>
            </div>
          </li>
          <!-- Màu khi chạm -->

          <!-- Màu khi chọn -->
          <li  class="pl-2" nz-submenu nzTitle="{{'mau_khi_chon' | translate}}">
            <div class="field-format-font menu-field ">
              <div class="container-font field-font">
                <div class="config-font-size">
                  <!-- Font-family -->
                  <div class="field-row-font" style="width:65%">
                    <mat-form-field style="width:100%">
                      <mat-label>Font</mat-label>
                      <mat-select [(value)]="class['menu__item-content--active']['font-family']"
                        [(ngModel)]="class['menu__item-content--active']['font-family']"
                        (nzOnAfterChange)="updateClass()">
                        <mat-option *ngFor="let font of fonts" [value]="font.value">{{font.name}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- Kích thước -->
                  <div class="field-row-size" style="width:35%">
                    <mat-form-field style="width: 100%">
                      <mat-label>{{'kich_thuoc' | translate}}</mat-label>
                      <input matInput type="number"
                        [ngModel]="class['menu__item-content--active']['font-size'] | vhnumber"
                        (ngModelChange)="class['menu__item-content--active']['font-size'] = $event + 'px'"
                        (blur)="updateClass()" />
                    </mat-form-field>
                  </div>
                </div>
                <!-- Kiểu chữ (Đậm/Nghiêm/Gạch chân/In hoa/Màu chữ) -->
                <div class="config-font">
                  <p class="title-font">{{'kieu_chu' | translate}}</p>
                  <div class="field-row">
                    <!-- In đậm -->
                    <button class="font-text-btn font-text-btn-bold" title="Bold" nz-button [nzType]="
                                               class['menu__item-content--active']['font-weight'] == 'bold'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['font-weight'] =
                                                   class['menu__item-content--active']['font-weight'] == 'bold'
                                                       ? '400'
                                                       : 'bold';
                                               updateClass()">
                      <span style="font-weight:500">B</span>
                    </button>
                    <!-- In nghiêng -->
                    <button class="font-text-btn font-text-btn-italic" title="Italic" nz-button [nzType]="
                                               class['menu__item-content--active']['font-style'] == 'italic'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['font-style'] =
                                                   class['menu__item-content--active']['font-style'] == 'normal'
                                                       ? 'italic'
                                                       : 'normal';
                                               updateClass()">
                      <i nz-icon nzType="italic" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- Gạch dưới -->
                    <button class="font-text-btn font-text-btn-underline" title="Underline" nz-button [nzType]="
                                               class['menu__item-content--active']['text-decoration'] == 'underline'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['text-decoration'] =
                                                   class['menu__item-content--active']['text-decoration'] == 'none'
                                                       ? 'underline'
                                                       : 'none';
                                               updateClass()">
                      <i nz-icon nzType="underline" nzTheme="outline" style="font-size: 14px"></i>
                    </button>
                    <!-- In hoa -->
                    <button class="font-text-btn font-text-btn-uppercase" title="Uppercase" nz-button [nzType]="
                                               class['menu__item-content--active']['text-transform'] == 'uppercase'
                                                   ? 'primary'
                                                   : 'default'" (click)="
                                               class['menu__item-content--active']['text-transform'] =
                                                   class['menu__item-content--active']['text-transform'] == 'none'
                                                       ? 'uppercase'
                                                       : 'none';
                                               updateClass()">
                      <span>AB</span>
                    </button>

                    <!-- Màu chữ -->
                    <div>
                      <input class="round-input-color" type="button"  [cpOKButton]="true" [(colorPicker)]="class['menu__item-content--active']['color']"
                        [style.background]="class['menu__item-content--active']['color']"
                        (colorPickerClose)="updateObject()" [cpWidth]="'230px'" [cpPositionRelativeToArrow]="true" />
                    </div>
                    <!-- Màu chữ -->

                  </div>
                </div>
              </div>
              <div class="config-name" style="display: flex; justify-content: space-between; align-items: center;">
                <p style="margin: 0;">{{'mau_nen' | translate}} </p>
                <div style="width:50%; max-width:50%;">
                  <input class="input-color w-100" type="button" [cpPositionRelativeToArrow]="true"
                    [cpOKButton]="true" [(colorPicker)]="class['menu__item--active']['background-color']"
                    [style.background]="class['menu__item--active']['background-color']"
                    (colorPickerClose)="updateObject()" />

                </div>
              </div>
            </div>
          </li>
          <!-- Màu khi chọn -->

        </ul>

      </li>
      <!-- HIỆU ỨNG MENU -->

      <!-- Cấu hình nội dung  -->
      <li nz-submenu nzTitle="{{'cau_hinh_noi_dung'| translate}}">
        <div class="color-pick">
          <span class="title w-50">{{'mau_nen' | translate}}</span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['information__right']['background-color']"
            [style.background]="class['information__right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
        <div class="color-pick">
          <span class="title w-50"> {{'mau_nut_chua_chon' | translate}} </span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['-btn-right']['background-color']"
            [style.background]="class['-btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
        <div class="color-pick">
          <span class="title w-50"> {{'mau_nut_da_chon' | translate}} </span>
          <input
            class="input-color w-50"
            type="button"
            [cpOKButton]="true" [(colorPicker)]="class['+btn-right']['background-color']"
            [style.background]="class['+btn-right']['background-color']"
            (colorPickerClose)="updateObject()"
            [cpWidth]="'230px'"
          />
        </div>
        <h2 class="mb-1">Menu</h2>
        <!-- Tài khoản của tôi -->
        <div *ngIf="!config.menu_item_hidden.user_info && !config.menu_item_hidden.user_password" class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'tai_khoan' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata.my_user_info['title_' + functionService.selectedLanguageCode]"
              (ngModelChange)="objectChoosing.staticdata.my_user_info['title_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <!-- Thông tin -->
        <div *ngIf="!config.menu_item_hidden.user_info" class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'thong_tin' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata.my_user_info.user_info['title_' + functionService.selectedLanguageCode]"
              (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info['title_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <!-- Đổi mật khẩu -->
        <div *ngIf="!config.menu_item_hidden.user_password" class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'doi_mat_khau' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata.my_user_info.user_password['title_' + functionService.selectedLanguageCode]"
              (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password['title_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <!-- Đơn mua -->
        <div *ngIf="!config.menu_item_hidden.user_purchase" class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'don_mua' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata.purchase['title_' + functionService.selectedLanguageCode]"
              (ngModelChange)="objectChoosing.staticdata.purchase['title_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <!-- Đăng xuất -->
        <div *ngIf="!config.menu_item_hidden.user_signout" class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'dang_xuat' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata.sigout['title_' + functionService.selectedLanguageCode]"
              (ngModelChange)="objectChoosing.staticdata.sigout['title_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateStaticData();"></textarea>
          </mat-form-field>
        </div>
        <ng-container *ngIf="!config.menu_item_hidden.user_info">
          <h2 class="mb-1">{{'noi_dung_ben_phai_muc_thong_tin' | translate}}</h2>
          <!-- Thông tin của tôi -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_thong_tin' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info['title_right_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info['title_right_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Quản lý thông tin hồ sơ của bạn để bảo mật tài khoản -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'mo_ta_thong_tin' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info['desc_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info['desc_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Email -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_email' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['email_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['email_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Họ tên -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_ho_ten' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['name_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['name_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập họ tên -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_ho_ten' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.error['name_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.error['name_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Số điện thoại -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_so_dien_thoai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['phone_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['phone_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập số điện thoại -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_so_dien_thoai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.error['phone_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.error['phone_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Số điện thoại không hợp lệ -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'so_dien_thoai_khong_hop_le' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.error['phone_invalid_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.error['phone_invalid_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Địa chỉ -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_dia_chi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['address_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['address_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập Địa chỉ -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_dia_chi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.error['address_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.error['address_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Nút lưu thông tin -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'nut_luu_thong_tin' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['content_button_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['content_button_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="!config.menu_item_hidden.user_password">
          <h2 class="mb-1">{{'noi_dung_ben_phai_muc_doi_mat_khau' | translate}}</h2>
          <!-- title đổi mật khẩu -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_doi_mat_khau' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password['title_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password['title_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- desc đổi mật khẩu -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'mo_ta_doi_mat_khau' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password['desc_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password['desc_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Mật khẩu hiện tại -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_mat_khau_hien_tai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.label['old_password_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.label['old_password_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập Mật khẩu hiện tại -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_mat_khau_hien_tai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.error['old_password_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.error['old_password_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Mật khẩu mới -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_o_mat_khau_moi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.label['new_password_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.label['new_password_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập Mật khẩu mới -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_mat_khau_moi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.error['new_password_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.error['new_password_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Xác nhận mật khẩu mới -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'xac_nhan_mat_khau_moi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.label['confirm_password_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.label['confirm_password_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Mật khẩu mới -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'bat_buoc_nhap_xac_nhan_mat_khau_moi' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.error['confirm_password_required_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.error['confirm_password_required_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Vui lòng nhập Mật khẩu mới -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'xac_nhan_mat_khau_moi_khong_khop' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_password.error['confirm_password_invalid_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_password.error['confirm_password_invalid_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Nút đổi mật khẩu -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'nut_doi_mat_khau' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.my_user_info.user_info.label['content_button_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.my_user_info.user_info.label['content_button_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="!config.menu_item_hidden.user_purchase">
          <h2 class="mb-1">{{'noi_dung_ben_phai_muc_don_mua' | translate}}</h2>
          <!-- title đơn mua -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_don_mua' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase['title_right_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase['title_right_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Đơn đã đặt -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tab_don_da_dat' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_placed_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_placed_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Đơn đã mua -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tab_don_da_mua' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_purchased_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_purchased_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Bạn chưa có đơn hàng nào -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'chua_co_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['no_orders_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['no_orders_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Mã đơn hàng -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'ma_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_code_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_code_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Ngày đặt -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'ngay_dat' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_date_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_date_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng tiền -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'don_hang' | translate}}: {{'tong_tien' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.label['order_total_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.label['order_total_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- title modal chi tiết đơn hàng -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_hop_thoai_thong_tin_don_hang' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail['title_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail['title_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- nút đóng modal -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'nut_dong_hop_thoai' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['close_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['close_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- hình ảnh -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_hinh_anh_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['img_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['img_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- tên sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_ten_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['name_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['name_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Giá sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_gia_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['price_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['price_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Số lượng sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_so_luong_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['quantity_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['quantity_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Thành tiền sản phẩm -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tieu_de_cot_thanh_tien_san_pham' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['total_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['total_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Tạm tính -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tam_tinh' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['subtotal_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['subtotal_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Tổng tiền -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'tong_tien' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['total_price_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['total_price_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
          <!-- Tổng: Phiếu thanh toán -->
          <div class="config-text" style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'phieu_thanh_toan' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata.purchase.modal_detail.label['payment_slip_' + functionService.selectedLanguageCode]"
                (ngModelChange)="objectChoosing.staticdata.purchase.modal_detail.label['payment_slip_' + functionService.selectedLanguageCode] = $event"
                (blur)="updateStaticData();"></textarea>
            </mat-form-field>
          </div>
        </ng-container>
      </li>

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['information']"
          [id_object]="objectChoosing._id">
        </app-borders-config>

        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[2])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
    </ul>

  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 3">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['information']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>